import { Suspense, type ReactElement } from 'react'
import { LoadingSpinner } from '@app/components/ui/LoadingSpinner/LoadingSpinner'

const withSuspense = (element: ReactElement) => (
  <Suspense fallback={<LoadingSpinner />}>{element}</Suspense>
)
export { withSuspense }
